import BaseController from "niteroi/packages/system/controllers/Base.controller";
import {SharedServices} from "niteroi/services/SharedServices";
import UIComponent from "sap/ui/core/UIComponent";

export default class Demo extends BaseController {
    public onInit(): void {
        super.onInit();
        SharedServices.updateTheme(this.getOwnerComponent() as UIComponent);
    }

    public onBeforeRendering() {
        super.onBeforeRendering();
    }
}
